@for (o of question().options; track o; let i = $index) {
<av-option-block
  [label]="o.body"
  [active]="isActive(o)"
  [attr.data-tid]="'survey/single/option/' + i"
>
  <input
    required
    type="radio"
    name="{{ question().id }}"
    [ngModel]="item().choice"
    [value]="o.score || o.body"
    (ngModelChange)="optionChange($event)"
  />
</av-option-block>
} @if (isError()) {
<div class="form-error" translate>Required</div>
}
